import { Box, Stack, styled } from '@mui/material'
import React from 'react'
import { COLORS } from '../../../constants/colors'
import GoTripLogo from '../images/GoTripLogo'
import SidebarButton from './SidebarButton'
import { RENDER_SIDEBAR_ROUTES } from '../../../configs/routes'
import { SIDEBAR_WIDTH } from '../../../constants/constants'
import { useSelector } from 'react-redux'
import { currentUserSelector } from '../../../stores/current-user/selector'

const Sidebar = () => {
  const currentUser = useSelector(currentUserSelector)

  return (
    <SidebarContainer>
      <Box height='80px' display='flex' justifyContent='center' alignItems='center'>
        <LogoBox src={GoTripLogo} />
      </Box>
      <OverflowStack paddingTop={6} spacing={4}>
        {RENDER_SIDEBAR_ROUTES.map((sidebar) => {
          const isHeaderHavePermission = (() => {
            // For Unprotected Routes
            if (sidebar.permissions.length < 1) return true
            if (!currentUser) return false
            const checkPermissionsList = sidebar.child
              ? sidebar.child.map((child) => child.permissions)
              : sidebar.permissions
            const isHavePermission = checkPermissionsList.some((perm) => currentUser.permissions.includes(perm))
            return isHavePermission
          })()
          if (!isHeaderHavePermission) return
          return (
            <Box key={sidebar.title}>
              <SidebarButton
                title={sidebar.title}
                path={sidebar.path}
                icon={sidebar.icon}
                isButton={Boolean(sidebar.path)}
              />
              {sidebar.child?.map((item) => (
                <SidebarButton
                  key={item.title}
                  title={item.title}
                  path={item.path}
                  isChild
                  isButton={Boolean(item.path)}
                />
              ))}
            </Box>
          )
        })}
      </OverflowStack>
    </SidebarContainer>
  )
}

const OverflowStack = styled(Stack)({
  overflowY: 'scroll',
  height: 'calc(100vh - 100px)'
})

const LogoBox = styled('img')({
  width: '114px'
})

const SidebarContainer = styled(Box)(({ theme }) => ({
  width: SIDEBAR_WIDTH,
  height: '100%',
  backgroundColor: COLORS.white,
  borderTopRightRadius: theme.spacing(8)
}))

export default Sidebar
